import {
  GUIDE_BETA_BADGE_TEXT_KEY,
  isGuideBeta,
  resolveGuideBetaBadge,
} from "../../../../shared/utils/guideBeta";

// Distintivo Beta. VIVA-1246, criterios de VIVA-1163.
//
// Va en las dos superficies de la TARJETA: el sello sobre la portada y, cuando
// el cobro esta habilitado, arriba del boton de compra —nunca debajo, que es el
// criterio literal—. Dentro del visor NO va: el distintivo es de la tarjeta, no
// de la guia ya abierta (decision del 22/09/2026), y por eso
// `obtener/contenido-guia` tampoco devuelve `isBeta`. El componente decide solo
// si aparece, igual que el disclaimer.
//
// El texto sale del esquema remoto cuando la clave exista (VIVA-1245) y, hasta
// entonces, del respaldo local de `guideBeta.js`. Eso es una excepcion
// consciente a lo que pedia el ticket —que no se entregara con respaldo—, y ahi
// esta escrito por que se acepto: "Beta" es la misma palabra en los dos idiomas,
// asi que no hay traduccion que inventar.
//
// Lo que este componente NO hace, y es criterio explicito: tocar el logotipo de
// Viva Nomada. La etiqueta Beta es del producto nuevo, no de la plataforma.
const GuideBetaBadge = ({
  guide,
  texts,
  isEnglish = false,
  textKey = GUIDE_BETA_BADGE_TEXT_KEY,
  className = "",
}) => {
  if (!isGuideBeta(guide)) return null;

  const label = resolveGuideBetaBadge(texts, textKey, isEnglish);
  if (!label) return null;

  return (
    <span className={`g2-beta-badge ${className}`.trim()}>{label}</span>
  );
};

export default GuideBetaBadge;
